import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useMutation, useQueryClient } from 'react-query';
import { addRSSFeedAPI } from './api';

const RSS_FEED = 'rssFeed';

export function useAddRSSFeed() {

  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL().toLowerCase();

  const { mutate, isLoading, isSuccess, isError, error } = useMutation(
    (feedURL) => addRSSFeedAPI(feedURL),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([RSS_FEED, tenantId]);
      },
    },
  );

  return {
    addRSSFeed: mutate,
    isSuccess,
    isLoading,
    isError,
    error: error?.statusCode === 400 ? 'invalidRSSFeed' : error?.message,
  };
}

